import React, {Component} from 'react';

class NormalDetails extends Component {

    static defaultProps = {
        data: "",
        empty:"",
        label: "",
        maxWidth: 252,
        style: {
            "wordBreak": "break-word"
        },
    };

    constructor(props) {
        super(props);
    }

    render() {
        let result =true;
        if(this.props.condition&&this.props.condition.length){
            if(this.props.condition.indexOf(this.props.dataSource.status)> -1){
                result = false
            }
        }

        return <div style={{display:"inline-block"}}>
            {
                result===true? <table cellPadding={0} cellSpacing={0} border={0} width={"98%"} style={{margin:"10px 0"}}><tbody><tr>
                    <td width={100} align={"right"} valign={"top"} style={{color: "#aaa6a6"}}>
                        {this.props.label}：
                    </td>
                    <td style={{width:this.props.maxWidth, color:"#252424",...this.props.style}} valign={"top"}>
                        {this.props.data}
                    </td>
                </tr></tbody></table>:null
            }

        </div>
    }
}

export default NormalDetails;
